const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
const GARAGE_TOKEN_KEY = "my-car-garage-token";
const GARAGE_INFO_KEY = "my-car-garage-info";

export function getGarageToken() { return window.localStorage.getItem(GARAGE_TOKEN_KEY); }
export function isGarageAuthenticated() { return Boolean(getGarageToken()); }
export function getGarageInfo() {
  try { return JSON.parse(window.localStorage.getItem(GARAGE_INFO_KEY) || "null"); } catch { return null; }
}
export function logoutGarage() {
  window.localStorage.removeItem(GARAGE_TOKEN_KEY);
  window.localStorage.removeItem(GARAGE_INFO_KEY);
}
export function garageHeaders() {
  const token = getGarageToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
export async function validateGarageSession() {
  const response = await fetch(`${API_URL}/garage-auth/me`, { headers: garageHeaders() });
  if (!response.ok) return false;
  const data = await response.json().catch(() => null);
  if (data?.garage) window.localStorage.setItem(GARAGE_INFO_KEY, JSON.stringify(data.garage));
  return true;
}
export async function loginGarage(code, password) {
  const response = await fetch(`${API_URL}/garage-auth/login`, {
    method: "POST", headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ code, password }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.message || "Unable to sign in.");
  window.localStorage.setItem(GARAGE_TOKEN_KEY, data.token);
  if (data.garage) window.localStorage.setItem(GARAGE_INFO_KEY, JSON.stringify(data.garage));
  return data;
}

// Sensitive actions require a fresh password, while preserving the current session token.
export async function verifyGaragePassword(password) {
  const currentToken = getGarageToken();
  const info = getGarageInfo();
  if (!info?.code || !password) return false;
  try {
    await loginGarage(info.code, password);
    const verified = Boolean(getGarageToken());
    if (currentToken) window.localStorage.setItem(GARAGE_TOKEN_KEY, currentToken);
    return verified;
  } catch {
    if (currentToken) window.localStorage.setItem(GARAGE_TOKEN_KEY, currentToken);
    return false;
  }
}
